import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  NConfigProvider,
  GlobalThemeOverrides,
  NGlobalStyle,
  NMessageProvider,
  enUS,
  dateEnUS,
} from 'naive-ui'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const themeOverrides: GlobalThemeOverrides = {
  common: {
    heightMedium: '40px',
    fontWeightStrong: '700',
    borderRadius: '10px',
    fontSize: '16px',
    primaryColor: '#00C2FFFF',
    primaryColorHover: '#52D6FFFF',
    primaryColorPressed: '#0097C7FF',
    primaryColorSuppl: '#006D8FFF',
    successColor: '#00FF57FF',
    errorColor: '#FF0000FF',
    successColorHover: '#29FF72FF',
    successColorPressed: '#00C744FF',
    successColorSuppl: '#008F31FF',
    infoColor: '#7BBC2FFF',
    infoColorHover: '#A3D864FF',
    infoColorPressed: '#5E8F24FF',
    infoColorSuppl: '#406219FF',
    errorColorHover: '#FF5252FF',
    errorColorPressed: '#C70000FF',
    errorColorSuppl: '#8F0000FF',
  },
  Button: {
    borderRadiusMedium: '50px',
    fontWeight: '700',
    paddingMedium: '1rem 2rem',
    textColor: '#FFFFFF',
  },
  Card: {
    color: '#1A1D1F',
    borderColor: 'transparent',
  },

  Divider: {
    color: '#1A1D1F',
  },

  Input: {
    color: '#FFFFFF',
    paddingMedium: '1rem',
    groupLabelColor: '#161616',
    groupLabelTextColor: '#858585',
  },
  List: {
    color: 'transparent',
    borderColor: '#858585',
  },
  Collapse: {
    titleFontSize: '16px',
    titleFontWeight: '700',
    dividerColor: '#858585FF',
    titleTextColor: '#858585FF',
  },
  Slider: {
    fillColor: '#4C4C4C',
    fillColorHover: '#000000',
  },
  Form: {
    feedbackHeightLarge: '12px',
    feedbackHeightMedium: '8px',
    feedbackHeightSmall: '4px',
  },
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), {
    "theme-overrides": themeOverrides,
    locale: _unref(enUS),
    "date-locale": _unref(dateEnUS),
    breakpoints: { xs: 0, s: 500, m: 700, l: 1200, xl: 1440, xxl: 1920 }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NMessageProvider), null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view),
          _createVNode(_unref(NGlobalStyle))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale", "date-locale"]))
}
}

})